<template>
  <article class="accessIndex">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">
              {{!hasAlreadyFilter?'Reservas de la locación actualmente':'Reservas de la locación '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
            </p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  v-if="getUserType() !== 'Counter'"
                  @click="$router.push({name: 'access'})"
                  class="breadcums__option"
                >
                  Resumen
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'location_access', params: {id: location_id}})"
                  class="breadcums__option"
                >
                  {{ location_name }}
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Reservas
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <div
              class="buttom_reload"
              @click="pagination_query=false;filterUsers(true);date_available=false;"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__body">
        <app-date-picker
          v-if="date_available"
          @filterQuery="pagination_query=false;filterUsersByButton($event)"
        >
        </app-date-picker>
      </div>
      <v-data-table
      :headers="headers"
      :items="accesses"
      :pagination.sync="sorter"
      hide-actions
      class="elevation-1">
      <template
        slot="items"
        slot-scope="props">
        <td>{{ props.item.email }}</td>
        <td>{{ props.item.user_rut }}</td>
        <td>{{ props.item.sublocation }}</td>
        <td>{{ dateFormatText($moment(props.item.start_time).format(" MM/DD/YYYY - h:mm a")) }}</td>
        <td>{{ dateFormatText($moment(props.item.end_time).format(" MM/DD/YYYY - h:mm a")) }}</td>
        <td>{{ dateFormatText($moment(props.item.update_date).format(" MM/DD/YYYY - h:mm a")) }}</td>
        <td>{{ props.item.state }}</td>
      </template>
    </v-data-table>
    <div
      class="table_card__footer"
      v-if="accesses.length>0&& pages > 1"
    >
      <v-pagination
        color="#1476FB"
        v-model="pagination.page"
        :length="pages"
      >
      </v-pagination>
      <label
        class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label
        class="accessIndex__pagination--current_text"
        v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
        {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
      </label>
      <label
        class="accessIndex__pagination--current_text"
        v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      sorter: {sortBy: 'in_date', descending: true, rowsPerPage: -1},
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
      initialRender:true,
      pages:2,
      months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
      pagination: {page:1,rowsPerPage:24},
      accesses: [],
      headers: [
        {text:'Correo', value: 'user'},
        {text:'Documento', value: 'user_rut'},
        {text:'Sala', value: 'in_date'},
        {text:'Desde', value: 'in_date'},
        {text:'Hasta', value: 'in_date'},
        {text:'Fecha actualización', value: 'in_date'},
        {text:'Estado', value: 'out_date'}
      ],
      titlelocation:'',
      months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
      location_id: '',
      location_name: ''
    }
  },
  watch: {
     'pagination.page': function (val, oldVal) {
        if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

        }
        else if(oldVal!=val&&val!=null&&oldVal!=null){
          this.pagination_query=true;
          this.filterUsers(false);
       }

      }
    }
    ,
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
      var sections=datex.split("-");
      var index=Number(sections[1])-1;
      sections[1]=this.months[index];
      datex=sections.join("/");
      return datex;
    },
    dateFormatText(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months_text[index];
        datex=sections.join(" ");
        return datex;
    },
    filterUsersByButton(dates){
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
      this.date =this.modifyDateFormatToStatus(object.date_from);
      this.date2 =this.modifyDateFormatToStatus(object.date_to);
      if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
        this.datePickerFirstClick=true;
      }
      // alert(this.datePickerFirstClick+this.date+this.date2);
      if(this.datePickerFirstClick){
        this.hasAlreadyFilter=true;
        this.filterSearchedDate=this.date;
        this.filterSearchedDate2=this.date2;
        this.filterUsers(false);
      }

    },
    filterUsers(defaultOption){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;
      //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate= ""
      var lastDate=""
      if(!defaultOption){
        initialDate=this.date;
        lastDate=this.date2;
         // initialDate=this.date;
         // lastDate=this.date2;
      }
      else if(this.initialRender&&this.$route.params.filter){
        this.initialRender=false;
        initialDate=this.$route.params.date;
        lastDate=this.$route.params.date2;
        this.date=this.$route.params.date;
        this.date2=this.$route.params.date2;
        this.filterSearchedDate=this.$route.params.date;
        this.filterSearchedDate2=this.$route.params.date2;
        this.datePickerFirstClick=true;
        this.hasAlreadyFilter=true;
        this.saved_default_option=false;
      }
      else{
        this.date= new Date().toISOString().substr(0, 10);
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
        this.hasAlreadyFilter=false;
      }
      try {
        this.$http.get('app/bookings/location_bookings',{
          params:{
            location_id: this.$route.params.id,
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page,
            current:!this.hasAlreadyFilter
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          console.log('index_location ', response)
          this.accesses=[];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // this.accesses = response.body.data;
          var vm =this;
          var temp = response.body.data;

          for(var booking in temp){
            var rut='';
            // if(temp[booking]["user_rut"]!=null){
            //   var rut = temp[booking]["user_rut"];
            //   rut = rut.substring(0, rut.length-1) + "-" + rut.substring(rut.length-1);
            // }
            vm.accesses.push({
              email:temp[booking]["email"],
              user_rut:temp[booking]["user_rut"],
              sublocation:temp[booking]["sublocation"],
              start_time:temp[booking]["start_time"],
              end_time: temp[booking]["end_time"],
              update_date: temp[booking]["update_date"],
              state: temp[booking]["state"],
            })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          /* console.table(vm.accesses); */
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
  }, /* Closed methods */
  mounted(){
    // this.pagination.rowsPerPage=12;
    this.filterUsers(true);
    this.titlelocation=this.$route.params.namex;
    this.location_id = this.$route.params.id;
    this.location_name = this.$route.params.location_name;
  }
}
</script>
<style>
.theme--light.v-pagination .v-pagination__item{
  color: #5A6B8E !important;
}
.theme--light.v-pagination .v-pagination__item--active{
  color: #FFFFFF !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/access/Index_location_booking.vue